import { types as t } from 'mobx-state-tree';

export const JobUserRead = t.model('JobUserRead', {
  notes: t.optional(t.boolean, true),
  files: t.optional(t.boolean, true),
});
